import { useEffect, useState, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react"
import cssClasses from "./CustomTab.module.css";
const CustomTab = ({ tabList = [], tabIndex = 0, rightComp = null }) => {
  const [state, setState] = useState(tabIndex)
  const [showLeftArrow, setShowLeftArrow] = useState(false)
  const [showRightArrow, setShowRightArrow] = useState(false)
  const tabsRef = useRef(null)

  useEffect(() => {
    setState(tabIndex)
  }, [tabIndex])

  useEffect(() => {
    checkForArrows()
    window.addEventListener("resize", checkForArrows)
    return () => {
      window.removeEventListener("resize", checkForArrows)
    }
  }, [])

  const checkForArrows = () => {
    if (tabsRef.current) {
      const { scrollWidth, clientWidth, scrollLeft } = tabsRef.current
      setShowLeftArrow(scrollLeft > 0)
      setShowRightArrow(scrollLeft + clientWidth < scrollWidth)
    }
  }

  const handleScroll = () => {
    checkForArrows()
  }

  const scrollLeft = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: -200, behavior: "smooth" })
    }
  }

  const scrollRight = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: 200, behavior: "smooth" })
    }
  }

  const activeComp = tabList.find((tab, index) => index === state)

  return (
    <div className={cssClasses.container}>
      <div className={`${rightComp ? "flex justify-between items-center" : ""}`}>
        <div className="flex items-center relative flex-1 mb-4">
          {showLeftArrow && (
            <button
              className="flex items-center justify-center h-10 w-10 flex-shrink-0 text-gray bg-white z-10 transition-all duration-200 hover:text-primary"
              onClick={scrollLeft}
              aria-label="Scroll tabs left"
            >
              <ChevronLeft size={20} />
            </button>
          )}

          <div
            className={`${cssClasses.titleWrapper} ${
              rightComp ? "flex-none" : "flex-1"
            }`}
            ref={tabsRef}
            onScroll={handleScroll}
            style={{
              msOverflowStyle: "none" /* IE and Edge */,
              scrollbarWidth: "none" /* Firefox */,
            }}
          >
            {tabList.map((tab, index) => {
              const isActive = index === state
              return (
                <div
                  key={index}
                    className={`${cssClasses.title} ${isActive ? cssClasses.titleActive : ""} ${tab.toBlur ? cssClasses.blur : ""}`}
                    onClick={() => setState(index)}
                >
                    {tab.startIcon}
                    {tab.title}
                    {tab.endIcon}
                </div>
              )
            })}
          </div>

          {showRightArrow && (
            <button
              className="flex items-center justify-center h-10 w-10 flex-shrink-0 text-gray bg-white z-10 transition-all duration-200 hover:text-primary"
              onClick={scrollRight}
              aria-label="Scroll tabs right"
            >
              <ChevronRight size={20} />
            </button>
          )}
        </div>
        {rightComp}
      </div>
      <div className="children h-full flex flex-1 flex-col overflow-hidden" key={state}>
        {activeComp?.component}
      </div>
    </div>
  )
}

export default CustomTab
